<template>
  <div class="flex-auto page-padding identifycode-page">
    <!-- <el-button class="back" type="text"
               @click="reback">返回</el-button> -->
    <!-- <div class="identify-tar-title">重置密码</div> -->
    <div class="identifycode-main">
      <div class="identifycode-container">
        <el-form class="identifycode-form">
          <el-form-item class="form-item">
            <div class="identifycode-title">通过手机找回密码</div>
          </el-form-item>
          <el-form-item>
            <div class="identifycode-label">
              点击获取验证码，短信将发送至手机<span class="phone-text">{{
                phone
              }}</span>
            </div>
          </el-form-item>
          <el-form-item class="form-item form-code">
            <input
              type="text"
              class="input-text form-input"
              v-model="identifycode"
              placeholder="请输入验证码"
            />
            <el-button
              class="form-btn"
              :disabled="disableButton"
              @click="getCode"
              ><span class="code-active" v-if="codetext">获取验证码</span>
              <span class="code-wait" :disabled="disableButton" v-if="!codetext"
                >{{ count }}s</span
              >
            </el-button>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              class="sign-button"
              :loading="loading"
              @click="confirm"
            >
              下一步
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import { api } from "@src/modules/forgetpassword/api/index.js";
import utils from "@src/common/utils";
export default {
  data() {
    return {
      loading: false,
      accountNumber: "",
      phone: "",
      identifycode: "",
      // verificationCode:'',
      codetext: true,
      disableButton: false,
      timerCount: this.codewaite,
      focusType: "",
      show: true,
      count: "",
      timer: null,
    };
  },
  created() {
    this.accountNumber = this.$route.query.accountNumber;
    this.phone = this.$route.query.phone;
  },
  methods: {
    reback() {
      this.$router.push({
        path: "/forgetPassword",
      });
    },
    getCode() {
      if (this.disableButton) {
        return;
      } else {
        this.codetext = false;
        const TIME_COUNT = 60;
        if (!this.timer) {
          this.count = TIME_COUNT;
          this.show = false;
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) {
              this.disableButton = true;
              this.count--;
            } else {
              this.show = true;
              this.disableButton = false;
              clearInterval(this.timer);
              this.timer = null;
              this.codetext = true;
            }
          }, 1000);
        }
        console.log("vertifycode");
        console.log(this.accountNumber, "=====this.accountNumber");
        this.$fetch(api.queryVerificationCode, {
          accountNumber: this.accountNumber,
        }).then((res) => {
          console.log(res, "===验证码");
        });
      }
    },
    confirm() {
      console.log(this.identifycode, "--this.identifycode");
      this.$fetch(api.checkVerificationCode, {
        verificationCode: this.identifycode,
        accountNumber: this.accountNumber,
      }).then((res) => {
        if (res.msgCode == "0") {
          this.$router.push({
            // path: '/newpassword', query: { accountNumber: this.accountNumber, identifycode: this.identifycode }
            path: "/userCode",
            query: {
              passTypeSet: "1",
              accountNumber: this.accountNumber,
              verificationCode: this.identifycode,
            },
          });
        } else {
          console.log(res, "====res");
          this.$message({ type: "error", message: res.msgContent });
        }
      });
    },
  },
};
</script>
<style lang="scss">
@import "~@src/common/assets/style/mixin";
.identifycode-page {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  width: 100vw;
  height: 100vh;
  margin: 0;
  position: absolute;
  overflow: hidden;

  left: 0;
  top: 0;
  .back {
    margin-top: 10px;
    font-size: 14px;
  }
  .identifycode-main {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .identifycode-container {
      margin-top: 80px;
      @include set_theme_color(background-color, blur-color);
      width: 380px;
      height: 350px;
      padding: 20px;
      border-radius: 5px;
      position: relative;
      // background-color: rgba(0, 8, 75, 0.8);
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      .identifycode-form {
        width: 100%;
        top: 50px;
        .identifycode-label {
          font-size: 14px;
          .phone-text {
            color: #66b1ff;
          }
        }
        .form-item {
          position: relative;

          .identifycode-title {
            font-size: 24px;
            text-align: center;
            margin-bottom: 30px;
            border-bottom: 2px solid;
            @include set_theme_color(border-color, top-menu-border-color);
          }
        }
        .form-code {
          position: relative;
          .input-text {
            padding-left: 8px;
            height: 40px;
          }
          .form-btn {
            position: absolute;
            text-align: center;
            right: 1px;
            height: 40px;
            font-size: 14px;
            width: 30%;
          }

          .form-input {
            width: 40px;
            height: 40px;
            padding: 0 20px 0 8px;
            width: 67%;
            @include set_theme_color(background-color, top-menu-bg-color);
            -moz-box-shadow: none !important;
            -webkit-box-shadow: none !important;
            box-shadow: none !important;
            border: 1px solid;
            @include set_theme_color(border-color, top-menu-border-color);
            @include set_theme_color(color, font-default-color);

            &:hover {
              @include set_theme_color(border-color, active-border-color);
            }

            &:focus {
              @include set_theme_color(border-color, active-border-color);
            }
          }
          .form-input-icon {
            position: absolute;
            top: 0px;
            left: 0px;
            width: 40px;
            height: 40px;
            text-align: center;

            i {
              font-size: 20px;
              line-height: 40px;
            }
          }
        }

        .sign-button {
          width: 100%;
          margin-top: 40px;
        }
      }
    }
  }
}
</style>